/**
 * Slideshow Dots Click Handler
 * Adds click functionality to Flickity slideshow dots
 * Used by slideshow sections to enable direct slide navigation
 */
(function() {
  window.initSlideshowDotClicks = function(sectionId) {
    var slideshowEl = document.getElementById('Slideshow-' + sectionId);
    if (!slideshowEl) return;

    function setupDotClicks() {
      if (!slideshowEl.classList.contains('flickity-enabled')) {
        setTimeout(setupDotClicks, 200);
        return;
      }

      // Get Flickity instance - try theme wrapper first, then raw instance
      var flickityWrapper = null;
      var flickityInstance = null;

      if (window.theme && window.theme.sections && typeof window.theme.sections._findInstance === 'function') {
        var sectionInstance = window.theme.sections._findInstance(sectionId);
        if (sectionInstance && sectionInstance.flickity) {
          flickityWrapper = sectionInstance.flickity;
        }
      }

      flickityInstance = slideshowEl.flickity || (window.Flickity && window.Flickity.data(slideshowEl));
      if (!flickityWrapper && !flickityInstance) return;

      // Find dots container
      var sectionContainer = document.querySelector('[data-section-id="' + sectionId + '"]');
      var dotsContainer = slideshowEl.querySelector('.flickity-page-dots') ||
                         (slideshowEl.parentElement && slideshowEl.parentElement.querySelector('.flickity-page-dots')) ||
                         (sectionContainer && sectionContainer.querySelector('.flickity-page-dots')) ||
                         (slideshowEl.closest('.natural-height-hero') && slideshowEl.closest('.natural-height-hero').querySelector('.flickity-page-dots'));

      if (!dotsContainer) return;

      var dots = dotsContainer.querySelectorAll('.dot');
      if (dots.length === 0) return;

      // Event delegation on container
      dotsContainer.addEventListener('click', function(e) {
        var dot = e.target.closest('.dot');
        if (!dot) return;

        e.preventDefault();
        e.stopPropagation();

        var dots = Array.from(dotsContainer.querySelectorAll('.dot'));
        var index = dots.indexOf(dot);
        if (index === -1) return;

        // Use wrapper's goToSlide method (handles fade transitions correctly)
        if (flickityWrapper && typeof flickityWrapper.goToSlide === 'function') {
          flickityWrapper.goToSlide(index);
        } else if (flickityInstance && typeof flickityInstance.select === 'function') {
          flickityInstance.select(index, true, true);
        }
      }, true);
    }

    setTimeout(setupDotClicks, 500);
  };
})();
